<mat-card teampage-whitepage-card class="mat-elevation-z0">
  <mat-card-content>
    <h1 class="question-mark">?</h1>
    <mat-icon>account_circle</mat-icon>
    <h1>Sorry! This team member does not exist.</h1>
  </mat-card-content>
</mat-card>
